/**
 * @description proxyを利用したjsonp読み込み
 * @param url 読み込むURL
 * @param callback コールバック関数
 * @param ttl キャッシュ保持時間(秒)
 * @param encoding エンコーディング
 */
export function jsonp(url: string, callback: (data: jsonp_data, status: string) => void, ttl: number = 60, encoding: string = 'UTF-8'): void {
  const proxy = 'https://kamenoi-hotels.com/' + 'proxy/index.php?';
  $.getJSON(proxy + 'callback=?', { url: url, encoding: encoding, ttl: ttl }, callback);
}

/**
 * jsonpが返すオブジェクト型
 *
 * @param {string} datetime proxyアクセス日時
 * @param {string} cache キャッシュデータの場合は1
 * @param {string} data 取得データをBase64エンコードした文字列
 * @param {string} error エラーメッセージをBase64エンコードした文字列
 * @param {string} url proxyに読み込みを指定したURL
 */
interface jsonp_data {
  datetime: string;
  cache: string;
  data: string;
  error: string;
  url: string;
}
